"use strict";

var _regeneratorRuntime = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keys = require("blockstack/lib/keys");

var _encryption = require("blockstack/lib/encryption");

var _model = _interopRequireDefault(require("../model"));

var _signingKey = _interopRequireDefault(require("./signing-key"));

var _groupMembership = _interopRequireDefault(require("./group-membership"));

var _helpers = require("../helpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var decrypted = true;

var BlockstackUser =
/*#__PURE__*/
function (_Model) {
  _inherits(BlockstackUser, _Model);

  function BlockstackUser() {
    _classCallCheck(this, BlockstackUser);

    return _possibleConstructorReturn(this, _getPrototypeOf(BlockstackUser).apply(this, arguments));
  }

  _createClass(BlockstackUser, [{
    key: "createSigningKey",
    value: function () {
      var _createSigningKey = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var key;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _signingKey.default.create();

              case 2:
                key = _context.sent;
                this.attrs.personalSigningKeyId = key._id;
                return _context.abrupt("return", key);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createSigningKey() {
        return _createSigningKey.apply(this, arguments);
      }

      return createSigningKey;
    }()
  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _ref, appPrivateKey, contentToSign, _ref2, signature;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.attrs.signingKeyId = 'personal';
                _ref = (0, _helpers.loadUserData)(), appPrivateKey = _ref.appPrivateKey;
                contentToSign = [this._id];

                if (this.attrs.updatedAt) {
                  contentToSign.push(this.attrs.updatedAt);
                }

                _ref2 = (0, _encryption.signECDSA)(appPrivateKey, contentToSign.join('-')), signature = _ref2.signature;
                this.attrs.radiksSignature = signature;
                return _context2.abrupt("return", this);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sign() {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }], [{
    key: "currentUser",
    value: function currentUser() {
      if (typeof window === 'undefined') {
        return null;
      }

      var userData = (0, _helpers.loadUserData)();

      if (!userData) {
        return null;
      }

      var username = userData.username,
          profile = userData.profile,
          appPrivateKey = userData.appPrivateKey;
      var publicKey = (0, _keys.getPublicKeyFromPrivate)(appPrivateKey);
      var Clazz = this;
      var user = new Clazz({
        _id: username,
        username: username,
        publicKey: publicKey,
        profile: profile
      });
      return user;
    }
  }, {
    key: "createWithCurrentUser",
    value: function createWithCurrentUser() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        var resolveUser = function resolveUser(user, _resolve) {
          user.save().then(function () {
            _groupMembership.default.cacheKeys().then(function () {
              _resolve(user);
            });
          });
        };

        try {
          var user = _this.currentUser();

          user.fetch().catch(function () {// console.error('caught error', e);
          }).finally(function () {
            // console.log(user.attrs);
            var userData = (0, _helpers.loadUserData)();
            var username = userData.username,
                profile = userData.profile,
                appPrivateKey = userData.appPrivateKey;
            var publicKey = (0, _keys.getPublicKeyFromPrivate)(appPrivateKey);
            user.update({
              username: username,
              profile: profile,
              publicKey: publicKey
            });

            if (!user.attrs.personalSigningKeyId) {
              user.createSigningKey().then(function (key) {
                (0, _helpers.addPersonalSigningKey)(key);
                resolveUser(user, resolve);
              });
            } else {
              _signingKey.default.findById(user.attrs.personalSigningKeyId).then(function (key) {
                (0, _helpers.addPersonalSigningKey)(key);
                resolveUser(user, resolve);
              });
            }
          });
        } catch (error) {
          reject(error);
        }
      });
    }
  }]);

  return BlockstackUser;
}(_model.default);

exports.default = BlockstackUser;

_defineProperty(BlockstackUser, "className", 'BlockstackUser');

_defineProperty(BlockstackUser, "schema", {
  username: {
    type: String,
    decrypted: decrypted
  },
  publicKey: {
    type: String,
    decrypted: decrypted
  },
  profile: {
    type: String,
    decrypted: decrypted
  },
  personalSigningKeyId: String
});